import React, { useEffect, useState } from 'react';
import { CalendarCheck, Phone } from 'lucide-react';
import { CONTACT } from '../lib/constants';
/** Fixed bottom conversion bar shown on mobile once the user leaves the hero. */
export function MobileStickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 560);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-border bg-white/95 shadow-lg backdrop-blur-md transition-transform duration-300 ease-smooth lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-120">
      <div className="flex items-stretch gap-2 p-3" data-id="element-121">
        <a href="#it-review" className="flex min-h-[48px] flex-[2] items-center justify-center gap-2 rounded-btn bg-ct-cyan px-4 text-[15px] font-bold text-white" data-id="element-122">
          <CalendarCheck className="h-5 w-5" aria-hidden data-id="element-123" />
          Book IT Review
        </a>
        <a href={CONTACT.phoneHref} aria-label={`Call CT Group on ${CONTACT.phone}`} className="flex min-h-[48px] flex-1 items-center justify-center gap-2 rounded-btn border border-border bg-white px-4 text-[15px] font-bold text-navy" data-id="element-124">
          <Phone className="h-5 w-5 text-ct-cyan" aria-hidden data-id="element-125" />
          Call
        </a>
      </div>
    </div>;
}